(() => {
  const replacements = [
    [/\bAll products\b/gi, "Shop All Goods"],
    [/\bFeatured products\b/gi, "Featured Goods"],
    [/\bRelated products\b/gi, "More Goods You May Like"],
    [/\bProduct details\b/gi, "Details"],
    [/\bProducts\b/g, "Goods"],
    [/\bproducts\b/g, "goods"],
    [/\bProduct\b/g, "Good"],
    [/\bproduct\b/g, "good"]
  ];
  const skipTags = new Set(["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "INPUT", "CODE", "PRE"]);
  const apply = (text) => replacements.reduce((next, [pattern, replacement]) => next.replace(pattern, replacement), text);
  const sweepTextNodes = (root = document.body) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || skipTags.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        if (!/\bproducts?\b/i.test(node.nodeValue || "")) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const next = apply(node.nodeValue || "");
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  };
  const sweepAttributes = (root = document.body) => {
    if (!root) return;
    const nodes = root.querySelectorAll ? root.querySelectorAll("[aria-label], [title], [placeholder]") : [];
    nodes.forEach((node) => ["aria-label", "title", "placeholder"].forEach((attr) => {
      const value = node.getAttribute(attr);
      if (value && /\bproducts?\b/i.test(value)) node.setAttribute(attr, apply(value));
    }));
  };
  const sweep = () => {
    document.title = apply(document.title || "");
    sweepTextNodes(document.body);
    sweepAttributes(document.body);
  };
  const schedule = () => window.requestAnimationFrame(() => window.requestAnimationFrame(sweep));
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule, { once: true }); else schedule();
  window.addEventListener("load", () => {
    sweep();
    window.setTimeout(sweep, 250);
    window.setTimeout(sweep, 1000);
    window.setTimeout(sweep, 2500);
  }, { once: true });
  const observer = new MutationObserver(() => schedule());
  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  window.__AUTOCOMMERCE_GOODS_LANGUAGE_ACTIVE__ = true;
})();